import { BaseOnePageMicrosoftModel } from '../../../../orchestration/microsoft/reports/models/base-one-page-microsoft-model';

export class MicrosoftOnePageModel extends BaseOnePageMicrosoftModel {
}
